import { useCallback, useState } from "react";
import type { CustomerSummary } from "./customerSummariesApi";

export type ClientDialogType = "notes" | "stats" | "helpdesk";

interface OpenClientDialog {
  type: ClientDialogType;
  client: CustomerSummary;
}

interface UseClientDialog {
  readonly clientFor: (type: ClientDialogType) => CustomerSummary | null;
  readonly openDialog: (type: ClientDialogType, client: CustomerSummary) => void;
  readonly closeDialog: () => void;
}

export function useClientDialog(): UseClientDialog {
  const [openClientDialog, setOpenClientDialog] = useState<OpenClientDialog | null>(null);

  const clientFor = (type: ClientDialogType) => (openClientDialog?.type === type ? openClientDialog.client : null);
  const openDialog = useCallback(
    (type: ClientDialogType, client: CustomerSummary) => setOpenClientDialog({ type, client }),
    [],
  );
  const closeDialog = useCallback(() => setOpenClientDialog(null), []);

  return { clientFor, openDialog, closeDialog };
}
